import { SystemPageKey } from '@internal/page/SystemPageKey'
import { compile, match } from 'path-to-regexp'
import { PageTypeKey } from 'utils/page/PageTypeKey'
import { TSearchResultsPageRouteParams } from './routingTable'
import { TRoute } from './TRoute'
import { queryParamsToString } from './urls/queryParamsToString'

export const searchResultsPageRoute = (
  routePath: string
): TRoute<TSearchResultsPageRouteParams> => {
  const matcher = match<TSearchResultsPageRouteParams['pathParams']>(
    routePath,
    {
      sensitive: true,
    }
  )
  const compiler = compile(routePath, {
    sensitive: true,
  })
  return {
    exec: (url: string) => {
      const matcherResult = matcher(url)
      if (!matcherResult) {
        return false
      }

      return {
        type: PageTypeKey.SystemPage,
        systemPageKey: SystemPageKey.SearchResults,
        url,
        pathParams: matcherResult.params,
      }
    },
    compile: (params: TSearchResultsPageRouteParams) => {
      const pathParams: TSearchResultsPageRouteParams['pathParams'] = {
        machineTypeSlug: params.pathParams.machineTypeSlug,
      }
      if (params.pathParams.brandSlug) {
        pathParams.brandSlug = params.pathParams.brandSlug
      }
      if (params.pathParams.modelSlug) {
        pathParams.modelSlug = params.pathParams.modelSlug
      }
      const url = compiler(pathParams)
      const queryString =
        params.queryParams && queryParamsToString(params.queryParams)

      return `${url}${queryString ? `?${queryString}` : ''}`
    },
  }
}
